import { StartupStateScreen } from "@/src/components/StartupStateScreen";
import { useStartup } from "@/src/hooks/useStartup";
import { useNotificationRouting } from "@/src/components/notificationRoutingContext";
import { Slot, router, usePathname, type Href } from "expo-router";
import React, { useEffect } from "react";

export default function AuthLayout() {
  const { status, retry } = useStartup();
  const { responseReady, hasPendingNotificationIntent } = useNotificationRouting();
  const pathname = usePathname();
  const isOnboarding = pathname?.endsWith("/onboarding");
  const isLogin = pathname?.endsWith("/login");
  const isRegister = pathname?.endsWith("/register");
  const isVerifyEmail = pathname?.endsWith("/verify-email");

  useEffect(() => {
    if (status === "signed_out" && !isLogin && !isRegister) {
      router.replace("/(auth)/login");
    } else if (status === "email_verification_required" && !isVerifyEmail) {
      router.replace("/(auth)/verify-email" as Href);
    } else if (status === "onboarding_required" && !isOnboarding) {
      router.replace("/(auth)/onboarding");
    } else if (status === "ready" && responseReady && !hasPendingNotificationIntent) {
      router.replace("/(tabs)");
    }
  }, [hasPendingNotificationIntent, isLogin, isOnboarding, isRegister, isVerifyEmail, pathname, responseReady, status]);

  if (status === "loading") return <StartupStateScreen mode="loading" />;
  if (status === "offline" || status === "recoverable_error") {
    return <StartupStateScreen mode="error" offline={status === "offline"} onRetry={retry} />;
  }
  if (status === "signed_out" && !isLogin && !isRegister) return <StartupStateScreen mode="loading" />;
  if (status === "email_verification_required" && !isVerifyEmail) return <StartupStateScreen mode="loading" />;
  if (status === "onboarding_required" && !isOnboarding) return <StartupStateScreen mode="loading" />;
  if (status === "ready") return <StartupStateScreen mode="loading" />;

  return <Slot />;
}
